import { CustomParams } from "../../types";
import { ExtensionController } from "./extensionController";

export class HtmlAdapterV3 extends ExtensionController {

	async render(target: HTMLElement, template: string, data?: CustomParams) : Promise<void> {
		console.log(target);
	}

}
